import React from "react"

import Image from "@/components/ui/image"
import { cn } from "@/lib/utils"

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl"
  showText?: boolean
  className?: string
}

const sizeClasses = {
  sm: "h-8",
  md: "h-12",
  lg: "h-16",
  xl: "h-24",
}

export function Logo({ size = "md", showText = true, className }: LogoProps) {
  const height = size === "sm" ? 32 : size === "md" ? 48 : size === "lg" ? 64 : 96
  const width = showText ? height * 3 : height

  return (
    <div className={cn("flex items-center", className)}>
      <Image
        src="/images/savwa-logo.png"
        alt="Savwa - Knowledge Platform"
        width={width}
        height={height}
        className={cn(sizeClasses[size], "object-contain")}
        priority
      />
    </div>
  )
}
